
import { importSync as i } from '@embroider/macros';
let d = window.define;
d("discourse/templates/wizard", function(){ return i("discourse/templates/wizard.js");});
d("discourse/routes/wizard", function(){ return i("discourse/routes/wizard.js");});
d("discourse/routes/wizard/index", function(){ return i("discourse/routes/wizard/index.js");});
d("discourse/templates/wizard/step", function(){ return i("discourse/templates/wizard/step.js");});
d("discourse/routes/wizard/step", function(){ return i("discourse/routes/wizard/step.js");});
